module.exports = __webpack_public_path__ + "img/al-dente.e6dc6efb.gif";